import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import pageTopCss from "./PageTop.module.css";
export default function PageTop(props) {
  const { pageTitle } = props;
  return (
    <>
      <Container fluid={true} className={`${[pageTopCss.container]} `}>
        <div className={`${pageTopCss.pageTopOverlay}`}></div>
        <Row>
          <Col lg={4} md={4} sm={12}></Col>
          <Col lg={4} md={4} sm={12} className={`${pageTopCss.title}`}>
            <h1>{pageTitle}</h1>
          </Col>
          <Col lg={4} md={4} sm={12}></Col>
        </Row>
      </Container>
    </>
  );
}
